import "@babel/polyfill";

import Vue from "vue";

import "normalize.css/normalize.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import i18n from "./language/index"; // Internationalization

import "@/styles/index.scss"; // global css
import "font-awesome/css/font-awesome.min.css";

import App from "./App";
import store from "./store/index";
import router from "./router/index";
import qs from "qs"; // 全局引用qs，转换数据格式

import Axios from "axios";

import "@/icons"; // icon
import "@/permission"; // permission control
import $mAssetsPath from "./commonConfig/assetsConfig"; // 资源路径
import "@/utils/rem"; // 适配

import { Message } from "element-ui";

import { Ohyeah } from "vue-ohyeah-scroll";
Vue.use(Ohyeah);

// 公共
import common from "./utils/commFunction";
import constant from "./const/const.js";
Vue.prototype.$common = common;
Vue.prototype.global = constant;

// 全局注册组件
import modal from "@/components/Modal/index";

import confirmModal from "@/components/Modal/confirmModal";
import noListData from "@/components/noListData/index";

Vue.component("modal", modal);

Vue.component("confirmModal", confirmModal);
Vue.component("noListData", noListData);

Vue.use(ElementUI);
Vue.use(ViewUI);

Vue.config.productionTip = true;
Vue.prototype.$mAssetsPath = $mAssetsPath;
Vue.prototype.$qs = qs;
Vue.prototype.$axios = Axios;
Vue.prototype.$Message = Message;
Vue.prototype.$Notice.config({
  top: 68,
  duration: 0,
});

new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: (h) => h(App),
});
